import { render, staticRenderFns } from "./UploadedFiles.vue?vue&type=template&id=0961c914&scoped=true&"
import script from "./UploadedFiles.vue?vue&type=script&lang=js&"
export * from "./UploadedFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961c914",
  null
  
)

export default component.exports